module.exports = __webpack_public_path__ + "static/media/autopilot-mini-icon.3a287fbe.png";